// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2d2sK","col":"styles_col__i0CCU"};